import { cloneDeep } from "lodash";

export const capFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

// Replaces undefined with null and strips empty-string keys so payload is Firebase-safe.
export const removeUndefined = (obj) => {
    return cleanObj(cloneDeep(obj));
};

// const cleanObj = (object) => {
//     Object.entries(object).forEach(([k, v]) => {
//         if (v === undefined) {
//             object[k] = null;
//         } else if (v && typeof v === "object") {
//             cleanObj(v);
//         }
//     });
//     return object;
// };

function cleanObj(object) {
    if (object === null || typeof object !== "object") {
        return object === undefined ? null : object;
    }
    if (Array.isArray(object)) {
        return object.map((item) => (item === undefined ? null : cleanObj(item)));
    }
    return Object.fromEntries(
        Object.entries(object)
            .filter(([key]) => key !== "" && key != null) // drop empty or null keys
            .map(([key, value]) => [key, value === undefined ? null : cleanObj(value)])
    );
}
